import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AdminmasterComponent } from './adminmaster/adminmaster.component';
@NgModule({
  declarations: [HeaderComponent, SidebarComponent, AdminmasterComponent],
  imports: [ CommonModule, RouterModule],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AdminlayoutModule { }
